import { render, staticRenderFns } from "./ScheduleResourceGrid.vue?vue&type=template&id=63a01f6c&"
import script from "./ScheduleResourceGrid.vue?vue&type=script&lang=js&"
export * from "./ScheduleResourceGrid.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleResourceGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports